import { useQuery } from "@tanstack/react-query";
import useApiClient from "../useApiClient";
import { useRegion } from "../regions";

type AdminQueryOptions = {
  database?: string;
  enabled?: boolean;
  refetchInterval?: number | false;
};

const useAdminQuery = (
  sql: string,
  parameters: unknown[] = [],
  options?: AdminQueryOptions,
) => {
  const api = useApiClient();
  const { region } = useRegion();
  const database = options?.database;
  const enabled = options?.enabled ?? true;
  const refetchInterval = options?.refetchInterval;
  return useQuery({
    queryKey: ["admin-query", region.id, sql, parameters, database],
    enabled,
    refetchInterval,
    queryFn: async () => {
      const { data, error } = await api.POST("/admin/query", {
        body: { sql, parameters, database },
      });
      if (error) throw error;
      if (!data) throw new Error("No data");
      return data;
    },
  });
};

export default useAdminQuery;
